/**
 * Dashboard Module
 * Módulo responsável pela inicialização e gerenciamento do dashboard
 */

export function initDashboardModule() {

    // Verificar se estamos na página do dashboard
    const isDashboardPage = document.body.getAttribute('data-page') === 'dashboard';

    if (!isDashboardPage) {
        return;
    }

    // Verificar se o usuário está autenticado
    if (!window.isAuthenticated) {
        return;
    }

    // Aguardar um pouco para garantir que todos os elementos estejam prontos
    setTimeout(() => {
        // Inicializando gráficos com dados do controller...
        initChartsWithData();
    }, 100);
}

/**
 * Inicializar gráficos com dados vindos do controller
 */
function initChartsWithData() {
    if (typeof window.dashboardData === 'undefined') {
        return;
    }

    const data = window.dashboardData;

    // Inicializar gráfico de O.S
    if (data.osChart && document.getElementById('chartDashOS')) {
        initOSChart(data.osChart);
    }

    // Inicializar gráfico de faturamento
    if (data.billingChart && document.getElementById('chartDashBilling')) {
        initBillingChart(data.billingChart);
    }

    // Inicializar gráfico de serviços
    if (data.servicesChart && document.getElementById('chart-servicos')) {
        initServicesChart(data.servicesChart);
    }
}

/**
 * Inicializar gráfico de O.S criadas vs concluídas
 */
function initOSChart(chartData) {
    const options = {
        series: chartData.series,
        chart: {
            height: 298,
            type: "line",
            margin: {
                left: 0
            },
            toolbar: {
                show: false
            },
            zoom: {
                enabled: false
            }
        },
        stroke: {
            curve: "smooth",
            dashArray: [0, 0, 3],
            width: [0, 0, 1]
        },
        fill: {
            opacity: [1, 1, 0.1]
        },
        markers: {
            size: [0, 0, 4],
            strokeWidth: 2,
            hover: {
                size: 4
            }
        },
        xaxis: {
            categories: chartData.categories,
            axisTicks: {
                show: false
            },
            axisBorder: {
                show: false
            }
        },
        grid: {
            show: true,
            xaxis: {
                lines: {
                    show: true
                }
            },
            yaxis: {
                lines: {
                    show: false
                }
            },
            padding: {
                top: 0,
                right: 0,
                bottom: 16,
                left: 10
            }
        },
        legend: {
            show: true,
            horizontalAlign: "center",
            offsetX: 0,
            offsetY: -10,
            markers: {
                width: 9,
                height: 9,
                radius: 6
            },
            itemMargin: {
                horizontal: 10,
                vertical: 0
            }
        },
        plotOptions: {
            bar: {
                columnWidth: "50%",
                barHeight: "50%"
            }
        },
        tooltip: {
            shared: true,
            y: [{
                formatter: function formatter(e) {
                    return e !== undefined ? e.toFixed(0) : e;
                }
            }, {
                formatter: function formatter(e) {
                    return e !== undefined ? e.toFixed(0) : e;
                }
            }]
        },
        colors: ['#A4A2FF', '#362EDB']
    };

    const chart = new ApexCharts(document.querySelector("#chartDashOS"), options);
    chart.render();
}

/**
 * Inicializar gráfico de faturamento
 */
function initBillingChart(chartData) {
    const options = {
        series: chartData.series,
        chart: {
            type: 'area',
            height: 350,
            fontFamily: 'airbnb_cereal, sans-serif',
            toolbar: {
                show: false
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'smooth',
            width: 4
        },
        xaxis: {
            categories: chartData.categories
        },
        colors: ['#4940FF', '#8EDD25'],
        fill: {
            type: 'gradient',
            gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.5,
                opacityTo: 0,
                stops: [0, 90, 100]
            }
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    }).format(val);
                }
            }
        }
    };

    const chart = new ApexCharts(document.querySelector("#chartDashBilling"), options);
    chart.render();
}

/**
 * Inicializar gráfico de serviços (donut)
 */
function initServicesChart(chartData) {

    console.log(chartData)

    if (chartData.series.length > 0) {

        const options = {
            series: chartData.series,
            labels: chartData.labels,
            chart: {
                type: "donut",
                height: 360,
                toolbar: {
                    show: false
                }
            },
            colors: ["#0F0C7A", "#2520B7", "#362EDB", "#7975FF", "#A4A2FF"],
            legend: {
                position: "bottom",
                markers: {
                    width: 10,
                    height: 10,
                    radius: 12
                },
                itemMargin: {
                    horizontal: 10,
                    vertical: 6
                }
            },
            dataLabels: {
                enabled: false,
                formatter: function formatter(val) {
                    return "".concat(val.toFixed(1), "%");
                }
            },
            tooltip: {
                y: {
                    formatter: function formatter(val) {
                        return "".concat(val, " servi\xE7os");
                    }
                }
            },
            plotOptions: {
                pie: {
                    donut: {
                        size: "70%",
                        labels: {
                            show: true,
                            name: {
                                show: true
                            },
                            value: {
                                show: true,
                                formatter: function formatter(val) {
                                    return "".concat(Math.round(val));
                                }
                            },
                            total: {
                                show: true,
                                label: "Total",
                                formatter: function formatter(w) {
                                    var total = w.globals.seriesTotals.reduce(function (a, b) {
                                        return a + b;
                                    }, 0);
                                    return "".concat(total);
                                }
                            }
                        }
                    }
                }
            },
            stroke: {
                width: 2
            },
            responsive: [{
                breakpoint: 768,
                options: {
                    chart: {
                        height: 320
                    },
                    legend: {
                        position: "bottom"
                    }
                }
            }]
        };

        const chart = new ApexCharts(document.querySelector("#chart-servicos"), options);
        chart.render();

    } else {
        $('#chart-servicos').html('<div class="text-center opacity-50 px-4"><span class="h1 icon-bg-md mx-auto mb-3"><i class="sg sg-chart-pie-slice"></i></span><p>Sem dados para exibir este gráfico no momento</p></div>')
    }


}

/**
 * personalização de botão de expasão dos cards */

document.addEventListener('DOMContentLoaded', () => {
    const btn = document.getElementById('btnDashMoreCards');
    const collapse = document.getElementById('dashMoreCards');
    if (!btn || !collapse) return;

    const label = btn.querySelector('.btn-label');
    const icon = btn.querySelector('.btn-icon');

    collapse.addEventListener('shown.bs.collapse', () => {
      label.textContent = 'Ver menos';
      icon.classList.remove('sg-arrow-down');
      icon.classList.add('sg-arrow-up');
    });

    collapse.addEventListener('hidden.bs.collapse', () => {
      label.textContent = 'Ver mais';
      icon.classList.remove('sg-arrow-up');
      icon.classList.add('sg-arrow-down');
    });
});


// Exportar função para uso global
window.initDashboard = initDashboardModule;
